import React, {useEffect, useRef, useState} from "react";
import {useMsal} from "@azure/msal-react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {useNavigate} from "react-router-dom";
import {Button, Col, Form, FormGroup, InputGroup, Row} from "react-bootstrap";
import {Formik} from "formik";
import styles from "./Customers.module.css";
import {connect} from "react-redux";
import {createCustomerAsync} from "./customersSlice";
import {apiRequest, loginRequest} from "../../authConfig";
import {setActiveLink} from "../navmenu/navbarSlice";

export const AddCustomer = () => {
    const formicRef = useRef<any>(null);
    const {instance, accounts} = useMsal();
    const dispatch = useAppDispatch();
    const failed = useAppSelector(state => state.customers.status === 'failed');
    const navigate = useNavigate();
    

    const [saved, setSaved] = useState<boolean>(false);

    useEffect(() => {
            dispatch(setActiveLink('/customers'));
        },
        [
            dispatch
        ]);
    
    useEffect(() => {
        if (saved && !failed) {
            navigate('/customers');
        }
        setSaved(false);
    }, [saved, failed, dispatch]);

    const requestApiAccessToken = async (): Promise<string> => {
        const request = {
            ...apiRequest,
            account: accounts[0],
        };

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        }
    };
    const saveCustomer = async ({name, active}
                                    : { name: string | undefined, active: boolean | undefined }) => {

        await dispatch(createCustomerAsync({
            data: {
                name: name ?? '',
                active: active ?? false
            },
            apiToken: await requestApiAccessToken()
        }));

        setSaved(true);
    }
    
    return (
        <Row>
            <Col xs={12}>
                <Formik
                    validateOnChange={true}
                    validateOnMount={true}
                    innerRef={formicRef}
                    enableReinitialize={true}
                    initialValues={{
                        name: '',
                        active: false
                    }}
                    onSubmit={console.log}
                    validate={values => {
                        const errors: { [key: string]: any } = {};
                        if (!values?.name) {
                            errors.name = 'Required';
                        }
                        return errors;
                    }}
                >
                    {({
                          handleChange,
                          values,
                          errors,
                          dirty
                      }) => (
                        <Form>
                            <Row>
                                <Col className="col-12 col-lg-6 mb-2">
                                    <Form.Group>
                                        <Form.Label>Name</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                id="name"
                                                name="name"
                                                type="text"
                                                value={values.name}
                                                onChange={handleChange}
                                                isInvalid={!!errors.name}
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col className="col-12">
                                    <Form.Group>
                                        <InputGroup/>
                                        <Form.Check type="checkbox">
                                            <Form.Check.Label>Enabled</Form.Check.Label>
                                            <Form.Check.Input
                                                id="active"
                                                name="active"
                                                type="checkbox"
                                                checked={values.active}
                                                onChange={handleChange}
                                            />
                                        </Form.Check>
                                    </Form.Group>
                                </Col>
                                <Col className="col-12 col-lg-6 mb-2">
                                    <div className={styles.right}>
                                        <FormGroup>
                                            <InputGroup>
                                                <Button
                                                    disabled={!!errors.name || !dirty}
                                                    onClick={() => saveCustomer(values)}
                                                >
                                                    Save
                                                </Button>
                                            </InputGroup>
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )
                    }
                </Formik>
            </Col>
        </Row>
    )
}

export default connect()(AddCustomer);
